import Mention, { MentionOptions } from '@tiptap/extension-mention';
import { NodeConfig, ReactNodeViewRenderer } from '@tiptap/react';

import { RichTextAreaPropsType } from '../../types';
import MentionNode from './MentionNode';

const MentionExtension = Mention.extend({
  addAttributes() {
    let attrs = {
      ...this.parent?.(),
      userId: {
        default: undefined,
      },
      teamUserId: {
        default: undefined,
      },
      guestUserId: {
        default: undefined,
      },
      email: {
        default: undefined,
      },
      avatar: {
        default: undefined,
      },
      name: {
        default: undefined,
      },
      highlight: {
        default: undefined,
      },
    };
    return attrs;
  },
  addNodeView() {
    return ReactNodeViewRenderer(MentionNode);
  },
} as Partial<NodeConfig<MentionOptions & { onMentionRemove: (userId: number) => void; onMentionAdd: RichTextAreaPropsType['onMentioneeAdd'] }>>);

export default MentionExtension;
